import React from 'react';

const Waitlists = () => {
  return <div>Waitlists Page</div>;
};

export default Waitlists;
